import React, { useState, useContext, useCallback } from 'react'
import { Spacer } from '@cleartrip/bento/components/Spacing'
import { Button } from '@cleartrip/bento/components/Button'
import { formatCurrency } from 'Utils'
import { AccountsContext } from 'AccountsContext'
import { isEmpty } from 'AccountsUtils'
import moment from 'moment'
import TimerBody from './TimerBody'
import { triggerHiFiveClevertap } from './hiFiveClevertap'
import SignUpStatus from './SignupStatus'
import { generateReferralLink } from '../../pages/Trips/trips.helper'

const ActiveFlow = ({ isTimerStart,
  setTimerStart }) => {
  const [startBtnBusy, setStartBtnBusy] = useState(false)
  const [refLink, setRefLink] = useState(null)
  const [linkExpirationTime, setLinkExpirationTime] = useState(null)

  const { search } = window.location
  const newSignup = new URLSearchParams(search).get('ns')

  const { hifiveStates } = useContext(AccountsContext)
  const showStatusMode = (hifiveStates?.isSuccess || hifiveStates?.isRunning)
  const linkExpirationStr = moment(hifiveStates?.linkExpirationTime).format('h:mm A,DD MMM')
  const [referralLinkEndStr, setReferralLinkEndStr] = useState(linkExpirationStr)

  let totalRewardValue = 0

  if (hifiveStates?.signedUpUsersList) {
    totalRewardValue = hifiveStates?.signedUpUsersList?.reduce((total, item) => {
      return total + item.rewardAmount
    }, 0)
  }
  const startHifive = useCallback(
    async () => {
      setStartBtnBusy(true)
      try {
        const res = await generateReferralLink()
        const { status, data } = res
        if (status === 200 || status === 201) {
          const time = new Date(data?.referralLinkDetails?.expiresAt).getTime()
          setTimerStart(true)
          setStartBtnBusy(false)
          setRefLink(data?.referralLinkDetails?.referralLink)
          setLinkExpirationTime(time)
          setReferralLinkEndStr(moment(time).format('h:mm A,DD MMM'))
        }

        triggerHiFiveClevertap(
          {
            action_name: 'Hi5_Start_timer',
            logged_in: 'yes',
            new_signup: (newSignup === 'yes' || newSignup === 'no') ? newSignup : 'no'
          }
        )
      } catch (e) {
        setStartBtnBusy(false)
        return ''
      }
    }, [setStartBtnBusy,
      setTimerStart,
      newSignup,
      setRefLink,
      setLinkExpirationTime,
      setReferralLinkEndStr]
  )

  return (
    <div className={`flex ${showStatusMode ? 'flex-column px-10 py-10' : ''}`}>

      <If condition={hifiveStates?.isRunning || hifiveStates?.isLanding}>
        <div className="flex flex-column flex-center">
          <h3 className="c-neutral-900 ls-normal fs-48 fw-400 lh-56">Get {formatCurrency(hifiveStates?.rewardAmountHiFive)}</h3>
          <Spacer className="pt-2" />
          <p className={`c-neutral-900 fs-4 fw-400 lh-24 ls-normal  ${!hifiveStates?.isLanding ? 'pb-6' : ''}`}> {`Invite
            ${hifiveStates?.requiredSignUpCountHiFIve} friends to sign up and earn ${formatCurrency(hifiveStates?.rewardAmountHiFive)}
            on Cleartrip`}
          </p>
        </div>
      </If>
      <div className="flex flex-column w-328 ">

        <If condition={hifiveStates?.isLanding || hifiveStates?.isRunning}>
          <div className={`${showStatusMode ? ' btr-16 ba' : 'bl brr-16'}  bc-black bg-white  p-6  `}>
            <TimerBody
              isRunning={hifiveStates?.isRunning}
              isTimerStart={isTimerStart}
              linkExpirationTime={!isEmpty(linkExpirationTime) ? linkExpirationTime :
                hifiveStates?.linkExpirationTime}
              expiryTime={hifiveStates?.expiryTime}
            />
            {(hifiveStates?.isLanding) && (
            <>
              <p className="c-neutral-900 fs-3 ta-center lh-review py-3">
                {`Ask your ${hifiveStates?.requiredSignUpCountHiFIve} friends to sign up
            to Cleartrip before the timer ends`}
              </p>
              <Button
                full={false}
                className="bg-neutral-900 b-none hover:bg-neutral-900
                w-100p br-8-imp px-8 hover:td-none"
                size="lg"
                busy={startBtnBusy}
                onClick={startHifive}
              ><p className="fw-600 fs-14 px-6">Start the timer</p>
              </Button>
            </>
            )}
          </div>
        </If>

        <If condition={hifiveStates?.isSuccess}>
          <div className="flex flex-column flex-center">
            <h3 className="c-neutral-900 ls-normal fs-56 fw-400">{formatCurrency(totalRewardValue)}</h3>
            <Spacer className="pt-2" />
            <p className="c-neutral-900 fs-40 lh-40 ls-normal fw-400 pb-8 pr-6"> added to wallet</p>
          </div>
        </If>
        <If condition={showStatusMode}>
          <SignUpStatus
            requiredSignUpCount={hifiveStates?.requiredSignUpCountHiFIve}
            signedUpUsers={hifiveStates?.signedUpUsersList}
            cycleExpirationTime={hifiveStates?.cycleExpirationTime}
            isTimerStart={isTimerStart}
            rewardAmount={hifiveStates?.rewardAmountHiFive}
            signupReward={hifiveStates?.signupReward}
            referralLinkHifive={refLink || hifiveStates?.referralLinkHifive}
            rewardProgressArray={hifiveStates?.rewardProgressArray}
            referralLinkEndStr={referralLinkEndStr}
          />
        </If>
      </div>

    </div>
  )
}

export default ActiveFlow
